<template>
<div class="chapter">
<div class="inner_page">
<section epub:type="frontmatter" title="Preface">
<p class="h1" id="ch-2"><span class="right_1" epub:type="pagebreak" id="page_ix" title="ix"><a href="#/text/9780253044174_Contents#ch2"><b>PREFACE</b></a></span></p>
<p class="noindent">Military history in general is not at the cutting edge of the discipline of history. And within military history, the focus is on the so-called New Military History writing, which emphasizes the social and cultural aspects of the military institutions and the effects of the armed forces on society. These aspects are certainly important, but we must note that, after all, most armies exist for fighting. So the study of the army as an institution in combat is worth pursuing. Following Carl von Clausewitz, one can say that the study of battles is like gold and silver in commercial transactions. And this is what the present volume intends to do. The objective is to study the Indian Army as an institution in the Malaya-Singapore Campaign of 1941–42. A lot of books have been written on this campaign, but the Indian Army, which constituted the biggest component of the Allied ground force in that theatre, has been left out of these studies. The present volume is a modest attempt to fill this gap. Unlike the present postmodernist slant, this work depends heavily on archival materials collected from three continents (Europe, Asia, and Australia) in order to build up the story. The battle narrative is integrated with analysis to offer a fresh insight into the Malaya-Singapore debacle. Since this book is aimed at English-speaking Western readers, Japanese names are given in the more common Western style. I sincerely hope that this book will encourage further studies in this genre.<span class="right_1" epub:type="pagebreak" id="page_x" title="x"></span></p>
</section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 9780253044174_Preface.vue?0899a436